// Constants
import { Endpoints } from "~constants/endpoints"

// Utils
import { Api } from "~utils/api"
import { urlQueryBuilder } from "~utils/utils"

// Shapes
import { PostFileOptionsShape } from "~shapes/file-upload"

const FileUploadService = {
  postPublicFile: async (file: File, options?: PostFileOptionsShape) => {
    const formData = new FormData()
    formData.append("file", file)

    let apiUrl = `${Endpoints.UPLOADS.URL}?isPublic=true`

    if (options) {
      const query = urlQueryBuilder(options)
      apiUrl = `${apiUrl}&${query}`
    }

    const response = await Api.post(apiUrl, formData)
    return response.data
  },
}

export default FileUploadService
